import * as React from 'react'
import { memo } from 'react'
const SvgStars = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 18.5 16"
  >
    <path d="m13.5 10.206 4.147-3.588.853.088-4.294 3.647L15.471 16l-.706-.441Zm-2.088-6.412L10.177.823 10.5 0l1.618 3.853ZM3.059 15.265l1.324-5.647L0 5.824l5.765-.5L8.029 0l2.265 5.324 5.765.5-4.382 3.794L13 15.265l-4.971-3Z" />
  </svg>
)
const Memo = memo(SvgStars)
export default Memo
